import {
  PERMISSIONS_REQUEST, PERMISSIONS_UPDATE_REQUEST, PERMISSIONS_SUCCESS, PERMISSIONS_UPDATE_SUCCESS,
  PERMISSIONS_SET_ALL_CHECKED, PERMISSIONS_SET_SEARCH_TEXT, PERMISSIONS_SET
} from '../constants/actionTypes';

export const PERMISSION_BUTTONS = {
  None: 0,
  Read: 1,
  ReadEdit: 2
};

const initialState = {
  data: {
    userRights: {
      id: 0,
      inheritedRights: [],
      personalRights: []
    },
    allRights: []
  },
  loading: false,
  updateSuccess: false,
  allChecked: null,
};

export default function permissions(state = initialState, action) {
  switch (action.type) {
    case PERMISSIONS_REQUEST:
    case PERMISSIONS_UPDATE_REQUEST:
      return {
        ...state,
        loading: true,
        updateSuccess: false
      };
    case PERMISSIONS_SUCCESS:
      return {
        ...state,
        data: action.permissions,
        loading: false,
        updateSuccess: false
      };
    case PERMISSIONS_UPDATE_SUCCESS:
      return {
        ...state,
        data: {
          userRights: [],
          allRights: []
        },
        loading: false,
        updateSuccess: true
      };
    case PERMISSIONS_SET:
    case PERMISSIONS_SET_ALL_CHECKED:
    case PERMISSIONS_SET_SEARCH_TEXT:
      return Object.assign({}, state, {
        ...action.payload
      });
    default:
      return state;
  }
}
